var TagalysCustomisations = {
  productTemplate: {
    render: function (html, args) {
      var props = args.props;
      var product = props.product;
      var helpers = props.helpers;

      var navigateToProductDetailPage = (event) => {
        helpers.navigateToProductDetailPage(event, product)
      }

      var productOptions = helpers.getTemplateOptions('product')
      var productLink = productOptions.productPageUrl(product)

      return html`
        <div class="product" onClick=${navigateToProductDetailPage}>
          <a
            class="product-link"
            href=${productLink}
            
          >
            <span class="product-image-container">
              ${product.featured_image ? (
                html `<img
                  class="product-image"
                  data-src=${product.featured_image.src}
                  alt=${product.title}
                />`
              ) : null}
            </span>
            <div class="product-details-wrap">
            <div class="product-details">
              <span class="product-name">
                  ${
                      (
                        product.title.toLowerCase().includes('backorder') ||
                        product.title.toLowerCase().includes('ships in')
                          ? product.title.split(/[\[(]/)[0].trim()
                          : product.title
                      )
                    }
                </span>
              <div class="feature-sec">
                <ul class="m-0">
                    <li class="catalog-product-stock-status out-of-stock">
                      <b>
                        <div class=${`dot ${
                              product.title.toLowerCase().includes('backorder') ||
                              product.title.toLowerCase().includes('ships in')
                                ? 'dot-red'
                                : 'dot-green'
                            }`}
                          ></div>
                      </b>
                      <span class="stock-text">
                          ${
                              product.title.toLowerCase().includes('backorder')
                                ? product.title
                                    .split(/[\[(]/)[1]
                                    .replace(/backorder/i, 'Pre-order')
                                    .replace(/\bon\b/gi, '')
                                    .replace(/[\])]/g, '')
                                    .trim()
                                : product.title.toLowerCase().includes('ships in')
                                  ? product.title
                                      .split(/[\[(]/)[1]
                                      .replace(/[\])]/g, '')
                                      .trim()
                                  : `${typeof product.available === 'number'
                                      ? product.available + ' in stock'
                                      : 'in stock'}`
                            }
                        </span>
                    </li>
                </ul>
              </div>
              ${helpers.isStorefrontAPICallPending() ? (
                html `<span class="skeleton-box"></span>`
              ) : (
                html `<span
                  class=${`product-prices${
                    helpers.isProductOnSale(
                      product.compare_at_price,
                      product.price
                    )
                      ? " discounted"
                      : " full-price"
                  }`}
                >
                  ${helpers.isProductOnSale(
                    product.compare_at_price,
                    product.price
                  )
                    ? html`
                        <span class="product-price-discounted"
                          >${helpers.formatCurrency(product.price)}</span
                        >
                      `
                    : null}
                  <span class="product-price-regular">
                    ${helpers.formatCurrency(
                      product.compare_at_price === null
                        ? product.price
                        : product.compare_at_price
                    )}
                  </span>
                </span>`
              )}
            </div>
          
          <div class="mobile_custom-dimenssion">
              <div class="product_details">
                <span>VIEW PRODUCT</span>
              </div>
            </div>
            </div>
            </a>
        </div>
      `;
    },
  }
};

TagalysCustomisations.setTagalysConfiguration = function () {
  var tagalysConfiguration = {
    api: {
      serverUrl: "https://api-r3.tagalys.com",
      credentials: {
        clientCode: "C48BCD03EB65C6C5",
        apiKey: "2ace4a8b6911673c971ca625298e8fcf"
      },
      storeId: "38678331531"
    },
    locale: "en-AU",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: "AUD",
      label: "$",
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: function() {
      // return true/false based on user's consent settings
      return true;
    },
    track: true
  };
  Tagalys.setConfiguration(tagalysConfiguration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var platformConfiguration = {
    platform: "Shopify",
    // replace with Shopify.country to set the shopper's chosen country
    countryCode: "AU",
    baseCountryCode: "AU",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "109d73bb02465c8f72d6f15e9c752cef",
      myShopifyDomain: "amahc.myshopify.com"
    },
    metafields: {
      products: []
    }
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initSearchSuggestions = function() {
  Tagalys.UIWidgets.SearchSuggestions.init("[data-search-input]", {
    searchResultsURL: "/search",
    templates: {
      widget: {
        options: {
          request: {
            collections: {
              limit: 10
            },
            products: {
              limit: 10
            }
          }
        }
      }
    }
  });
};

TagalysCustomisations.initSearchResults = function() {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results]", {
    callbacks: {
       onSuccessfulAPICall: function(response, helpers) {
         if(response.hasOwnProperty('total')){
           document.title = `Search: ${response.total} results found - A Man And His Cave`
         }
         return response
       }
     },
    templates: {
      checkboxFilterItem: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        const onFilterClick = (event) => {
          event.stopPropagation();
          if (props.filterItem.selected) {
            helpers.clearFilter(props.filterId, props.filterItem.id);
          } else {
            helpers.applyFilter(props.filterId, props.filterItem.id);
          }
        };

        return html`
          <li
            class="filter-item"
            data-filter-item-id=${props.filterItem.id}
            onClick=${onFilterClick}
          >
            <span class="filter-checkbox-and-label">
              <input
                class="checkbox"
                checked=${props.filterItem.selected}
                type="checkbox"
              />
              <span class="filter-item-label-and-count">
                <span class="filter-item-label">${props.filterItem.name}</span>
                ${props.showMatchingProductsCount
                  ? html`
                      <span class="filter-item-count">(${props.filterItem.count})</span>
                    `
                  : null}
              </span>
            </span>
            ${props.children}
          </li>
        `;
      },
    },
      product: {
        callbacks: {
          afterEveryRender: function (helpers) {
            // called after every product render
            // initialse the carousel for the product images here
          }
        },
        render: TagalysCustomisations.productTemplate.render
      },
      sortOptions: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;
          var sortOptions = helpers.getSortOptions();
          var appliedSortOption = helpers.getAppliedSortOption();

          var applySortOption = (event) => {
            helpers.applySortOption(event.target.value);
          };

          return html`
            <div class="sort-options-container">
              <span class="sort-by-label">
                ${labels.sortOptions.sortBy}
              </span>
              <select
                class="sort-options"
                value=${appliedSortOption.id}
                onchange=${applySortOption}
              >
                ${sortOptions.map((sortOption) => {
                  return html`
                    <option value=${sortOption.id}>${sortOption.label}</option>
                  `;
                })}
              </select>
            </div>
          `;
        },
      },
      filters: {
        options: {
          collapsible: true,
          autoCollapse: false,
          expandTopNFiltersByDefault: 10
        },
      },
      noResults: {
        options: {
          widgets: [{
            widgetId: "97eaa7a8c02d0b5740e7",
            options: {
              templates: {
                product: TagalysCustomisations.productTemplate
              }
            }
          }]
        }
      },
      paginationLinks: {
        options: {
          showFirstPageLink: false,
        }
      },
    }
  });
};